module.exports = __webpack_public_path__ + "img/aboutMy.a1fc555f.png";